import React from "react";

const ObjectivesYEE = () => {
  const objectivesData = [
    {
      title: "Course Objectives:",
      items: [
        "To elucidate fundamental principles & theories underpinning entrepreneurship.",
        "To cultivate skills essential for ideation, opportunity recognition, & market analysis.",
        "To facilitate the development of strategic planning & execution capabilities.",
        "To provide insights into effective resource management & financial planning.",
        "To foster an entrepreneurial mindset conducive to innovation & adaptability.",
      ],
      color: "text-green-600",
    },
    {
      title: "Course Outcomes:",
      items: [
        "Demonstrate a nuanced understanding of entrepreneurial concepts & frameworks.",
        "Possess the ability to identify & evaluate business opportunities effectively.",
        "Exhibit proficiency in crafting comprehensive business plans tailored to specific ventures.",
        "Showcase adeptness in strategic decision-making & problem-solving within entrepreneurial contexts.",
        "Develop effective communication & negotiation skills vital for stakeholder engagement.",
        "Cultivate resilience & adaptability crucial for navigating the dynamic landscape of entrepreneurship.",
      ],
      color: "text-purple-600",
    },
  ];
  return (
    <div className="my-10 " id="objectives">
      <div className="max-w-6xl mx-auto bg-sdbodywhiteywhitebody bg-opacity-70 shadow-lg rounded-lg p-8">

        <div className="md:flex md:gap-8 space-y-5 md:space-y-0">
          {objectivesData.map((section, index) => (
            <div key={index} className="md:w-1/2">
              <h3
                className={`text-lg md:text-2xl font-semibold mb-4 ${section.color}`}
              >
                {section.title}
              </h3>
              <ul className="space-y-4 list-disc list-inside">
                {section.items.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-4">
                    <img
                      src="/image-fix/pointers/inspiration-svgrepo-com.svg"
                      alt="icon"
                      className="w-8 h-8 mt-1"
                    />
                    <span className="text-base">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ObjectivesYEE;
